import { lazy, Suspense } from 'react'
import { cn } from './primitives'

/**
 * A Lottie/dotLottie scene (files live in /anim, precached with the app shell so they play offline —
 * which matters, since the first one is "no connection"). The player (~70 KB) is loaded on first use
 * only. `recolor` shifts the artwork's hue so a stock purple/blue animation reads in the app's red.
 */
const Player = lazy(() => import('@lottiefiles/dotlottie-react').then((m) => ({ default: m.DotLottieReact })))

export const LOTTIE = {
  noConnection: '/anim/no-connection.lottie',
} as const

export function LottieScene({ src, size = 160, recolor = true, loop = true, className }: { src: string; size?: number; recolor?: boolean; loop?: boolean; className?: string }) {
  return (
    <div className={cn('shrink-0', recolor && 'lottie-recolor', className)} style={{ width: size, height: size }} aria-hidden>
      <Suspense fallback={null}>
        <Player src={src} loop={loop} autoplay style={{ width: size, height: size }} />
      </Suspense>
    </div>
  )
}
